import {Autocomplete, Text} from '../1elements'
import {useEffect, useState} from 'react'
import ApiService from '../../common/ApiCalls'

const autocompleteSx = {
    padding: 0,
    '& .MuiInputBase-root': {
        padding: 0
    },
    '& .MuiAutocomplete-inputRoot': {
        maxHeight: '29px'
    },
    '& .MuiInputBase-input': {
        height: '10px'
    }
}

const ContractorSearch = ({disabled, setValue, value, validation, showError}) => {
    const [contractorOptions, setContractorOptions] = useState([])
    const [searchWord, setSearchWord] = useState('')
    const updateSearchWord = (e) => {
        setSearchWord(e.target.value)
    }

    const setOrganization = (newValue) => {
        setValue(newValue)
    }

    useEffect(()=>{
        if(searchWord.length > 0){
            const keyword = {searchInput: searchWord}
            ApiService().searchContractorAccountByName(keyword)
                .then((res)=> {
                    setContractorOptions(res)
                })
                .catch((err)=> {
                    console.log('There was an error on searchContactByName: ', err)
                })
        }else{
            setContractorOptions([])
        }
    }, [searchWord])

    return (
        <div>
            <Text type={'fieldLabel'}>Organization<span className={'requiredAsterisk'}>*</span></Text>
            <Autocomplete sx={autocompleteSx} options={contractorOptions} optionLabel={'name'}
                          onChangeAutocomplete={setOrganization} value={value} onChangeTextField={updateSearchWord}
                          validation={validation} showError={showError} disabled={disabled}
            />
        </div>
    )
}

export default ContractorSearch
